import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  minutes?: number;
}
export function CountdownTimer({
  minutes = 15
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(minutes * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center gap-2 md:gap-4 justify-center md:justify-start" data-id="element-24" data-mp="1ach88bspvw1y">
      <div className="flex flex-col items-center" data-id="element-25" data-mp="15dnvwmp62b3d">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-26" data-mp="15exudczxllaj">
          {format(h)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-27" data-mp="34onvwa2ss5b5">
          Horas
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-28" data-mp="1c0ydu07brkub">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-29" data-mp="1h01mdumik971">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-30" data-mp="1gxovut2owqid">
          {format(m)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-31" data-mp="171c1dszbm8mk">
          Min
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-32" data-mp="1us7pog4kilp2">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-33" data-mp="1zoy7b7w0tpcl">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-34" data-mp="1l1mu71k6xxad">
          {format(s)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-35" data-mp="1pzoflt53a8p0">
          Seg
        </span>
      </div>
    </div>;
}